import eventBus from '../../../general/js/event-bus';
import BaseComponent from '../../../general/js/base-component';
import {EVENT_AUTH_TRIGGER_CLICK} from "../../../general/js/app";

export default class AuthTriggerComponent extends BaseComponent{
    constructor() {
        super(...arguments);

        this.onClick = this.onClick.bind(this);
        this.init();
    }

    init() {
        this.element.addEventListener('click', this.onClick);
    }

    onClick(e) {
        e.preventDefault();
        eventBus.emit(EVENT_AUTH_TRIGGER_CLICK);
    }

    onDestroy() {
        this.element.removeEventListener('click', this.onClick);
    }
}



// WEBPACK FOOTER //
// ./app/components/auth-modal/js/auth-trigger.component.js